import {
  forwardRef,
  memo,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { Tabs, type TabItem } from '@kula-ai/components';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { InterviewActivityStepProps } from './AddInterviewActivity.interface';

export const InterviewActivityCommunication = memo(
  forwardRef<StepFormApi, InterviewActivityStepProps>(({ payloadRef }, ref) => {
    const [tabValue, setTabValue] = useState('candidate-communication');

    useImperativeHandle(
      ref,
      () => ({
        validate: async () => true,
        syncToPayload: () => {
          payloadRef.current.communication = {
            ...payloadRef.current.communication,
            activeSubTab: tabValue,
          };
        },
      }),
      [payloadRef, tabValue]
    );

    const tabItems: TabItem[] = useMemo(
      () => [
        {
          label: 'Candidate communication',
          value: 'candidate-communication',
          panel: <div>Candidate Communication Content</div>,
        },
        {
          label: 'Interviewer communication',
          value: 'interviewer-communication',
          panel: <div>Interviewer Communication Content</div>,
        },
        {
          label: 'Self-schedule slot selection email',
          value: 'self-schedule-slot-selection-email',
          panel: <div>Self-schedule slot selection email Content</div>,
        },
      ],
      []
    );

    return (
      <Flex>
        <Tabs.Root
          variant="side"
          items={tabItems}
          value={tabValue}
          onValueChange={setTabValue}
          className="w-full"
          panelClassName="px-6"
        />
      </Flex>
    );
  })
);

InterviewActivityCommunication.displayName = 'InterviewActivityCommunication';
